import { router } from "expo-router"
import React from "react"
import { Platform } from "react-native"

import { ENVIRONMENT } from "@/base/environment"
import { logger } from "@/base/logger"

import type { Href } from "expo-router"

export default function useInitialRoute() {
  const [canNavigate, setCanNavigate] = React.useState(false)
  React.useEffect(() => {
    setCanNavigate(true)
  }, [])
  const initialRouteName = process.env.EXPO_PUBLIC_INITIAL_ROUTE

  React.useEffect(() => {
    if (
      __DEV__ &&
      Platform.OS !== "web" &&
      Boolean(initialRouteName) &&
      canNavigate &&
      !ENVIRONMENT.isEndToEndTest
    ) {
      logger.debug(`[useInitialRoute]: ${initialRouteName}`)
      router.navigate(initialRouteName as Href)
    }
  }, [canNavigate, initialRouteName])
}
